import { render, staticRenderFns } from "./chartererSoa.vue?vue&type=template&id=3d4b8c9b&scoped=true"
import script from "./chartererSoa.vue?vue&type=script&lang=js"
export * from "./chartererSoa.vue?vue&type=script&lang=js"
import style0 from "./chartererSoa.vue?vue&type=style&index=0&id=3d4b8c9b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d4b8c9b",
  null
  
)

export default component.exports